import axios from "axios";
let url = process.env.REACT_APP_URL_API_INFRA || "";

export default axios.create({
  baseURL: url,
  headers: {
    "operKey": "02bd1b481c775a76cf83d6dace64bb33138a7d82cfafb8fc6726b91cbfa58d52",
    "Content-type": "application/json",
  },
});
